import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'summary' })
export class SummaryTextTransformer implements PipeTransform {
  transform(value: string | null | undefined, limitChar: number = 50): string {
    const etc = value?.toString()?.length! > limitChar ? ' ... ' : '';
    return value?.toString().slice(0, limitChar) + etc;
  }
}